import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { baseButtonStyles } from './LytBaseButton';
const StyledToastCloseButton = styled.button.withConfig({
    shouldForwardProp: (prop) =>
        !['isCompact', 'isIconOnly', 'customColor'].includes(prop),
})`
    ${baseButtonStyles}
    background-color: ${({ theme }) =>
        theme.components.lyt_button.toast_close.background.default};
    color: ${({ customColor, theme }) =>
        customColor || theme.components.lyt_button.toast_close.text.default};

    &:not(:disabled):hover {
        background-color: ${({ theme }) =>
            theme.components.lyt_button.toast_close.background.default};
        color: ${({ customColor, theme }) =>
            customColor ||
            theme.components.lyt_button.toast_close.text.default};
    }

    &:not(:disabled):active {
        background-color: ${({ theme }) =>
            theme.components.lyt_button.toast_close.background.default};
        color: ${({ customColor, theme }) =>
            customColor ||
            theme.components.lyt_button.toast_close.text.default};
    }

    &:focus-visible {
        background-color: ${({ theme }) =>
            theme.components.lyt_button.toast_close.background.default};
        outline: 2px solid
            ${({ theme }) =>
                theme.components.lyt_button.toast_close.border.focus};
        outline-offset: 1px;
    }

    &:disabled {
        background-color: ${({ theme }) =>
            theme.components.lyt_button.toast_close.background.disabled};
        color: ${({ theme }) =>
            theme.components.lyt_button.toast_close.text.disabled}4D;

        & svg,
        & svg line,
        & svg polyline,
        & svg path,
        & svg rect,
        & svg polygon {
            stroke: ${({ theme }) =>
                theme.components.lyt_button.toast_close.text.disabled}4D;
            fill: ${({ theme }) =>
                theme.components.lyt_button.toast_close.text.disabled}4D;
        }
    }
`;
const LytToastCloseButton = ({
    isCompact = false,
    customColor = null,
    ...props
}) => {
    return (
        <StyledToastCloseButton
            isCompact={isCompact}
            customColor={customColor}
            {...props}
        />
    );
};
LytToastCloseButton.propTypes = {
    isCompact: PropTypes.bool,
    customColor: PropTypes.string,
};
export default LytToastCloseButton;
